module.exports = __webpack_public_path__ + "static/media/Resume-20251203.dd667f32.pdf";